<template>
  <section class="list">
    <ul class="swiper-wrapper portrait">
      <li
        v-for="(cell, index) in cellList"
        :key="`movie_series_cell_${index}`"
        class="swiper-slide"
      >
        <SeriesPortraitCell
          :cell-info="cell"
          :thumbnail-info="thumbnailInfo"
          @click-fn="selectCell(cell)"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import { getEventListByType } from '@/common/util/event.util'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { get } from 'lodash'
import { parseUrl } from 'query-string'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import SeriesPortraitCell from '@/components/play/bottom-tab/SeriesPortraitCell'

export default {
  name: 'MovieSeriesCellList',
  components: {
    SeriesPortraitCell
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    contentInfo: {
      type: Object
    }
  },
  data () {
    return {
      isImageLoaded: false
    }
  },
  methods: {
    selectCell (cell) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(cell.event_list)
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      const fromList = get(this.$route, ['query', 'list'], 'n').toLowerCase() === 'y'
      const referer = get(this.$route, ['query', 'referer'], null)
      if (referer !== null) {
        if (fromList) {
          query.referer = this.$route.fullPath
          query.list = 'y'
        } else {
          query.referer = referer
        }
      }
      let section = url.split('/').pop()
      this.$router.replace({
        name: PATH_NAME_PLAYER,
        params: {
          section
        },
        query: query
      })
    }
  }
}
</script>
